import { useDispatch } from 'react-redux'
import { ROUTES } from '@constants/index'
import { setLoadingPageAction } from '@redux/slices/workflowSlice'
import { useClaimRecord } from '@hooks/useClaimRecord'
import { useInsuranceUsage } from '@hooks/useInsuranceUsage'
import { drawerEventEmitter } from '@utils/drawerEventEmitter'
import { getInsuranceToggleState } from '@utils/insuranceToggleUtil'

type UseInsuranceBenefitsUsageReturn = {
  addInsuranceBenefits: () => void
  removeInsuranceBenefits: () => void
}

/**
 * Handle add / remove benefits from commmerce F/E
 */
export const useInsuranceBenefitsUsage = (): UseInsuranceBenefitsUsageReturn => {
  const dispatch = useDispatch()
  const { claimRecord, claimRecordDeleted } = useClaimRecord()
  const { enableInsuranceUsage, disableInsuranceUsage } = useInsuranceUsage()

  // show drawer or enable insurance usage
  const addInsuranceBenefits = () => {
    const { toggleOn, allowOn } = getInsuranceToggleState({ claimRecord, claimRecordDeleted })
    if (toggleOn) return

    if (allowOn) {
      dispatch(setLoadingPageAction(enableInsuranceUsage))
      drawerEventEmitter.openDrawer({ target: ROUTES.LOADING })
    } else {
      drawerEventEmitter.openDrawer({ target: ROUTES.INSURANCE_MEMBER })
    }
  }

  // disable insurance usage
  const removeInsuranceBenefits = () => {
    const { toggleOn } = getInsuranceToggleState({ claimRecord, claimRecordDeleted })
    if (!toggleOn) return

    dispatch(setLoadingPageAction(disableInsuranceUsage))
    drawerEventEmitter.openDrawer({ target: ROUTES.LOADING })
  }

  return {
    addInsuranceBenefits,
    removeInsuranceBenefits,
  }
}
